import { useEffect } from 'react';
export default function useOnClickOutside(refs, handler) {
  var flag = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  useEffect(function () {
    var listener = function listener(event) {
      if (refs && refs.some(function (item) {
        return !item.current || item.current.contains(event.target);
      })) {
        return;
      }
      handler(event);
    };
    if (flag) {
      document.addEventListener('mousedown', listener);
      document.addEventListener('touchstart', listener);
    } else {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    }
    return function () {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [refs, handler, flag]);
}